var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('main',[(_setup.currentPage === _setup.LandsidePage.Home)?_c(_setup.LandsideHomePage):(_setup.currentPage === _setup.LandsidePage.Product)?_c(_setup.LandsideProductPage):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }